export default __webpack_public_path__ + "static/media/tip4.922dec96.svg";